
const Topbar = () => {
  return (
    <div className="container-fluid topbar px-5 d-none d-lg-block">
      <div className="row gx-0 align-items-center">
        <div className="col-lg-8 text-center text-lg-start mb-2 mb-lg-0">
          <div className="d-flex flex-wrap">
            <a href="#" className="text-white small me-4">
              <i className="fas fa-map-marker-alt text-white me-2"></i>Find A Location
            </a>
            <a href="tel:+919082280240" className="text-white small me-4">
              <i className="fas fa-phone-alt text-white me-2"></i>+919082280240
            </a>
            <a href="mailto:compliance@optionbricks.in" className="text-white small me-0">
              <i className="fas fa-envelope text-white me-2"></i>compliance@optionbricks.in
            </a>
          </div>
        </div>
        <div className="col-lg-4 text-center text-lg-end">
          <div className="d-inline-flex align-items-center" style={{ height: '45px' }}>
            <div className="dropdown">
             <p>SEBI RESEARCH ANALYST : INH000017408  </p>
              <div className="dropdown-menu rounded"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
